// extracted by mini-css-extract-plugin
module.exports = {"noticeNum":"noticeNum--3vPFT","box":"box--2PxYq","close":"close--3m8dK"};